import { StyledSelect } from "../common.style";
import { Option } from "../../primitives";

interface SellerTypeCardMarketDropDownProps {
  sellerType: string;
  setSellerType: (arg1: string) => void;
}

export const SellerTypeCardMarketDropDown = ({
  sellerType,
  setSellerType,
}: SellerTypeCardMarketDropDownProps) => {
  return (
    <StyledSelect
      value={sellerType}
      onChange={(e) => setSellerType(e.target.value)}
    >
      <Option value="">All Sellers</Option>
      <Option value="professional">Professional</Option>
      <Option value="powerseller">Powerseller</Option>
    </StyledSelect>
  );
};
